<template>
	<div class="product-index pt-2">
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="title">
			<template v-if="selectedOrderedProduct" v-slot:app-bar-btn>
				<v-btn color="primary" dark @click="reloadIndex()"><v-icon>mdi-reload</v-icon></v-btn>
			</template>
			<v-row no-gutters class="ma-2 align-center">
				<div>
					<h2 v-if="selectedOrderedProduct">
						製造番号：{{ selectedOrderedProduct.product_number }}
					</h2>
					<p v-if="selectedOrderedProduct">品名：{{ selectedOrderedProduct.product.name }}</p>
				</div>
				<div class="ma-2">
					<v-btn fav class="mr-2 pointer" @click="resetOrderedProduct" v-if="selectedOrderedProduct"
						>選択解除</v-btn
					>
				</div>
				<v-btn color="primary" dark @click="openSearchProduct" v-if="!selectedOrderedProduct">
					<v-icon class="mr-2">mdi-magnify</v-icon>部品表選択
				</v-btn>
				<!-- <v-btn color="primary" dark @click="openSearchProductForImport">
					<v-icon class="mr-2">mdi-plus</v-icon>既存製品からインポート
				</v-btn> -->
			</v-row>

			<div class="table-container px-2">
				<table>
					<thead>
						<tr>
							<th
								v-for="(header, index) in headers"
								:key="'th-' + index"
								:class="header.class"
								:width="header.width"
							>
								{{ header.text }}
							</th>
						</tr>
					</thead>
					<tbody>
						<OrderComponentRecord
							v-for="orderComponent in orderComponents"
							:key="orderComponent.id"
							:orderComponent="orderComponent"
							@updateOrderComponent="updateOrderComponent"
							@reloadIndex="reloadIndex"
						/>
					</tbody>
				</table>
				<p v-if="orderComponents.length == 0" class="text-center caption">データがありません</p>
				<v-row
					no-gutters
					class="pa-2 align-center justify-center"
					v-if="orderedProductWildcardFlag"
				>
					<v-col class="text-center">
						<v-btn v-if="selectedOrderedProduct" @click="openNewOrderComponent">
							<v-icon class="pointer"> mdi-plus-circle-outline </v-icon>
							部品追加
						</v-btn>
					</v-col>
					<v-col class="text-center">
						<v-btn v-if="selectedOrderedProduct" @click="openCopyFromExistDialog">
							<v-icon class="pointer"> mdi-plus-circle-outline </v-icon>
							既存製品からインポート
						</v-btn>
					</v-col>
					<v-col class="text-center">
						<v-btn v-if="selectedOrderedProduct" @click="openFromCSVDialog">
							<v-icon class="pointer"> mdi-plus-circle-outline </v-icon>
							CSVからインポート
						</v-btn>
					</v-col>
				</v-row>
			</div>
		</CommonFlame>
		<SearchOrderedProduct ref="search" @setOrderedProduct="setOrderedProduct" />
		<SearchProductForImport ref="fromExist" @reloadOrderComponents="reloadIndex" />
		<CreateDialog
			ref="newOrderComponent"
			:orderedProduct="selectedOrderedProduct"
			@reloadIndex="reloadIndex"
		/>
		<ImportFromCSV ref="fromCSV" @reloadIndex="reloadIndex" />
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import Qs from "qs"
import PaginationModule from "../../modules/PaginationModule.vue"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import SearchOrderedProduct from "./components/SearchOrderedProduct.vue"
import OrderComponentRecord from "./components/OrderComponentRecord.vue"
import CreateDialog from "./components/CreateDialog.vue"
import SearchProductForImport from "./components/SearchProductForImport.vue"
import ImportFromCSV from "./components/ImportFromCSV.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		SearchOrderedProduct,
		OrderComponentRecord,
		CreateDialog,
		SearchProductForImport,
		ImportFromCSV,
	},
	data() {
		return {
			mainTitle: "製品",
			title: "部品表",
			rules,
			common: common,
			selectedOrderedProduct: null,
			searchedOrderedProducts: [],
			orderedProductWildcardFlag: false,
			headers: [
				{
					text: "操作",
					value: "quantity",
					width: "100px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "部品品番",
					value: "part_number",
					width: "150px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "部品名",
					value: "part_name",
					width: "200px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "数量",
					value: "quantity",
					width: "70px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "単価",
					value: "unit_price",
					width: "150px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "備考",
					value: "remarks",
					width: "250px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "添付",
					value: "attachedFiles",
					width: "200px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
			],
			orderComponents: [],
		}
	},
	mounted() {},
	methods: {
		openFromCSVDialog() {
			this.$refs.fromCSV.openDialog(this.selectedOrderedProduct.id)
		},
		openCopyFromExistDialog() {
			this.$refs.fromExist.openDialog(this.selectedOrderedProduct.id)
		},
		openNewOrderComponent() {
			this.$refs.newOrderComponent.openDialog()
		},
		setOrderComponents(orderComponents) {},
		updateOrderComponent() {},
		openSearchProduct() {
			this.$refs.search.openDialog()
		},
		setOrderedProduct(selectedOrderedProduct) {
			console.log(selectedOrderedProduct)
			this.selectedOrderedProduct = selectedOrderedProduct
			this.orderComponents = selectedOrderedProduct.order_components
			if (this.selectedOrderedProduct.product.wildcard) {
				this.orderedProductWildcardFlag = true
			} else {
				this.orderedProductWildcardFlag = false
			}
		},
		resetOrderedProduct() {
			this.selectedOrderedProduct = null
			this.orderComponents = []
		},
		reloadIndex() {
			this.fetchOrderComponents()
		},
		fetchOrderComponents() {
			if (this.selectedOrderedProduct) {
				const headers = authenticate.setHeader()
				axios
					.get("/erp/v1/parts_list/order_components.json", {
						headers,
						params: {
							ordered_product_id: this.selectedOrderedProduct.id,
						},
					})
					.then((response) => {
						this.orderComponents = response.data.order_components
					})
					.catch((err) => {
						console.log(err)
						errorHandling.errorResponse(err)
					})
			}
		},
	},
}
</script>
<style scoped lang="scss">
@import "../../stylesheet/variable.scss";

table {
	border-collapse: separate;
	text-align: center;
	max-height: 1000px;
}
th,
td {
	border: 1px gray solid;
	padding: 3px;
	background: white;
	font-weight: bold;
}
tr {
	border-bottom: solid 1px gray;
}
th {
	background-color: $sub-color;
	color: #fff;
	min-width: 110px;
	text-align: center;
	position: sticky;
	top: 0;
}
</style>
